import { Button } from "components/Button/Button"
import { Empty } from "components/Empty/Empty"
import { PageNotFoundIcon } from "icons/PageNotFoundIcon"
import { useNavigate } from "react-router"

export const PageNotFound = () => {
	const navigate = useNavigate()

	return (
		<Empty
			Icon={PageNotFoundIcon}
			title="Page not found"
			description="The resource you are looking for does not exist."
		>
			<Button
				size="large"
				onClick={() => navigate("/check-authorization", { replace: true })}
			>
				Go to home
			</Button>
		</Empty>
	)
}
